import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const raw = localStorage.getItem("mm_user");
    if (raw) {
      try {
        const u = JSON.parse(raw);
        api.get("/me").then(({ data }) => {
          setUser(data);
          localStorage.setItem("mm_user", JSON.stringify(data));
        }).catch(() => {
          setUser(u);
        }).finally(() => setLoading(false));
      } catch {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, []);

  const signup = async (name, league_name) => {
    const { data } = await api.post("/auth/signup", { name, league_name });
    localStorage.setItem("mm_user", JSON.stringify(data));
    setUser(data);
    return data;
  };

  const signin = async (league_name) => {
    const { data } = await api.post("/auth/login", { league_name });
    localStorage.setItem("mm_user", JSON.stringify(data));
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("mm_user");
    setUser(null);
  };

  const updateUser = (next) => {
    setUser(next);
    try { localStorage.setItem("mm_user", JSON.stringify(next)); } catch (e) { /* ignore */ }
  };

  return (
    <AuthCtx.Provider value={{ user, loading, signup, signin, logout, updateUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
